<template>
	<div class="map-echart-list">
		<div class="map-echart-list-cell margin-top30">
			<divBox>
				<averageUsePower></averageUsePower>
			</divBox>
		</div>
		<div class="map-echart-list-cell margin-top30">
			<divBox>
				<averageEleMile></averageEleMile>
			</divBox>
		</div>
		<div class="map-echart-list-cell margin-top30">
			<divBox>
				<!-- <warn10day></warn10day> -->
				<averageSpeed></averageSpeed>
			</divBox>
		</div>
		<!-- SOC值区间 -->
		<div class="map-echart-list-cell margin-top30">
			<divBox>
				<!-- <changeElectricityTimes></changeElectricityTimes> -->
				<SOCValueRange></SOCValueRange>
			</divBox>
		</div>
		<!-- 充换电次数 -->
		<div class="map-echart-list-cell margin-top30">
			<divBox>
				<!-- <nightCharingTimes></nightCharingTimes> -->
				<changeNumber></changeNumber>
			</divBox>
		</div>
		<!-- 充换电电量（度） -->
		<div class="map-echart-list-cell margin-top30">
			<divBox>
				<changeElectricityMeasure></changeElectricityMeasure>
			</divBox>
		</div>
		<!-- 24h充换电次数分布 -->
		<div class="map-echart-list-cell margin-top30">
			<divBox>
				<changeAndCharing24hours></changeAndCharing24hours>
			</divBox>
		</div>
		<!-- 换电里程（km） -->
		<div class="map-echart-list-cell margin-top30">
			<divBox>
				<changeMiles></changeMiles>
			</divBox>
		</div>

		<div class="map-echart-list-cell map-echart-list-cell-half margin-top30">
			<divBox>
				<socAverageUsePower></socAverageUsePower>
			</divBox>
		</div>
		<div class="map-echart-list-cell map-echart-list-cell-half margin-top30">
			<divBox>
				<socAverageMiles></socAverageMiles>
			</divBox>
		</div>
		<div class="map-echart-list-cell map-echart-list-cell-half margin-top30">
			<divBox>
				<socAverageSpeed></socAverageSpeed>
			</divBox>
		</div>
		<div class="map-echart-list-cell map-echart-list-cell-half margin-top30">
			<divBox>
				<socAverageChangeTime></socAverageChangeTime>
			</divBox>
		</div>

		<div class="map-echart-list-cell map-echart-list-cell-half margin-top30">
			<divBox>
				<MileageAndSOC></MileageAndSOC>
			</divBox>
		</div>

		<div class="map-echart-list-cell map-echart-list-cell-half margin-top30">
			<divBox>
				<VelocitySimulation></VelocitySimulation>
			</divBox>
		</div>
	</div>
</template>

<script>
	// 电池健康状态
	import BatteryHealthStatus from "@/components/echart/siteCharts/carAddChart.vue";
	
	import averageUsePower from "../singleCarEcharts/averageUsePower.vue";
	import averageEleMile from "../singleCarEcharts/averageEleMile.vue";
	import changeElectricityMeasure from "../singleCarEcharts/changeElectricityMeasure";
	// import changeElectricityTimes from "../singleCarEcharts/changeElectricityTimes.vue";
	// import nightCharingTimes from "../singleCarEcharts/nightCharingTimes.vue";
	// import warn10day from "../singleCarEcharts/warn10day.vue";
	import changeNumber from '../singleCarEcharts/changeNumber'
	import averageSpeed from '../singleCarEcharts/averageSpeed'
	import SOCValueRange from '../singleCarEcharts/SOCValueRange'
	// import nightChangeTimes from "../singleCarEcharts/nightChangeTimes.vue";
	import changeMiles from "../singleCarEcharts/changeMiles.vue";
	import socAverageUsePower from "../singleCarEcharts/socAverageUsePower.vue";
	import options24hours from "../singleCarEcharts/options24hours.vue";
	import socAverageMiles from "../singleCarEcharts/socAverageMiles.vue";
	import socAverageSpeed from "../singleCarEcharts/socAverageSpeed.vue";
	import changeAndCharing24hours from "../singleCarEcharts/changeAndCharing24hours.vue";
	import socAverageChangeTime from "../singleCarEcharts/socAverageChangeTime.vue";
	import divBox from '../divBox'

	import MileageAndSOC from '../singleCarEcharts/MileageAndSOC'
	import VelocitySimulation from '../singleCarEcharts/VelocitySimulation'
	export default {
		components: { 
			BatteryHealthStatus, 
			changeAndCharing24hours,
			divBox, 
			averageUsePower, 
			options24hours,
			averageEleMile, 
			changeElectricityMeasure, 
			// changeElectricityTimes, 
			// nightCharingTimes, 
			// warn10day, 
			averageSpeed,
			changeNumber,
			SOCValueRange,
			// nightChangeTimes, 
			changeMiles, 
			socAverageUsePower, 
			socAverageMiles,
			socAverageSpeed, 
			socAverageChangeTime,
			MileageAndSOC,
			VelocitySimulation,
		},
		data() {
			return {};
		},
		methods: {},
		filters: {},
		mounted() {},
		// 销毁定时器
		beforeDestroy: function() {}
	}
</script>

<style lang="scss">
	@import './index.scss';
</style>